import React, { FC, useEffect, useMemo, useState } from 'react';
import { FlexBox, useBreakpoint, useIsMobile } from "@brg/ui";
import { AppTester } from "../../../supporting";
import { useModal } from 'core';
import urlApi from 'shared/actions/urlApi';
import { useProfile } from '@brg/auth';
import {
  LegalsWarningWrapper,
  LegalsApproveButton,
  LegalsText
} from './styles';
import { LinkTo } from 'shared/constants/linkTo';
import { useTranslation } from "react-i18next";

const DOCUMENT_ID = 'hsedesign_1bcca84a-49e8-426b-a01b-f88efcf7d18c';

const LegalsWarning: FC = () => {
  const modal = useModal();
  const is430 = useBreakpoint(430);
  const { t, i18n } = useTranslation();
  const isMobile = useIsMobile();
  const profile = useProfile();
  const [legalsList, setLegalsList] = useState<string[]>([])
  const isHSEDesign = AppTester.isHSEDesign();
  const isAcademy = AppTester.isAcademy();
  const isLPU = AppTester.isLPUDesign();
  
  const legalsLink = isHSEDesign ? process.env.REACT_APP_URL_HSEDESIGN_RU : process.env.REACT_APP_URL_DEZIIIGN;

  const privacyLink =
    i18n.language === 'ru' ? 'https://www.hse.ru/data_protection_regulation' : 'https://www.hse.ru/en/data_protection_regulation';

  const userShouldSignDocument = useMemo(() => (!isLPU && !!legalsList?.length && !!legalsList?.find((item: string) => item ===  DOCUMENT_ID)), [legalsList])

  const handleAcceptLegalsClick = () => {
    if (profile && profile?.accountId) {
      urlApi()?.acceptUserSign(profile.accountId, DOCUMENT_ID)
      .then((r) => {
        if (r.status === 200) {
          setTimeout(() => {
            setLegalsList(legalsList?.filter((i) => i !== DOCUMENT_ID))
          }, 1500)
        }
      })
      .catch((err) => console.error(err))
      .finally(() => {
        setTimeout(() => {
          setLegalsList(legalsList?.filter((i) => i !== DOCUMENT_ID))
        }, 1500)
      })
    }
  }

  useEffect(() => {
    if (profile && profile?.accountId) {
      urlApi()?.checkUserSign(profile.accountId).then((r: any) => setLegalsList(r))
    }
  }, [profile]);

  if (!userShouldSignDocument) {
    return null;
  }

  return (
    <>
    {userShouldSignDocument && (
      <LegalsWarningWrapper>
        <FlexBox style={{ padding: isMobile ? '15px 10px' : '0 0 0 0'}} align={'center'} alignMobile={'center'} direction='row' directionMobile='column' wrap={'nowrap'} width={'calc(80%)'} widthMobile={'calc(100%)'}>
          <LegalsText>
            {t('text.cookiesAgreement.part_1')}&nbsp;
          <a href={`${legalsLink}${LinkTo.legals}`} target={'_blank'}>{t('text.cookiesAgreement.part_2')}</a> {t('text.cookiesAgreement.part_3')} <a href={isHSEDesign || isAcademy ? privacyLink : `${legalsLink}${LinkTo.privacy}`}  target={'_blank'}>{t('text.cookiesAgreement.part_4')}</a> {t('text.cookiesAgreement.part_5')}
          </LegalsText>
          <LegalsApproveButton onClick={handleAcceptLegalsClick}>{t('text.cookiesAgree')}</LegalsApproveButton>
        </FlexBox>
      </LegalsWarningWrapper>
    )}
    </>
  )
}

export default LegalsWarning;
import React, { FC, useEffect, useMemo, useState } from 'react';
import { FlexBox, useBreakpoint, useIsMobile } from "@brg/ui";
import { AppTester } from "../../../supporting";
import { useModal } from 'core';
import urlApi from 'shared/actions/urlApi';
import { useProfile } from '@brg/auth';
import {
  LegalsWarningWrapper,
  LegalsApproveButton,
  LegalsText
} from './styles';
import { LinkTo } from 'shared/constants/linkTo';
import { useTranslation } from "react-i18next";

const DOCUMENT_ID = 'hsedesign_1bcca84a-49e8-426b-a01b-f88efcf7d18c';

const LegalsWarning: FC = () => {
  const modal = useModal();
  const is430 = useBreakpoint(430);
  const { t, i18n } = useTranslation();
  const isMobile = useIsMobile();
  const profile = useProfile();
  const [legalsList, setLegalsList] = useState<string[]>([])
  const isHSEDesign = AppTester.isHSEDesign();
  const isAcademy = AppTester.isAcademy();
  const isLPU = AppTester.isLPUDesign();
  
  const legalsLink = isHSEDesign ? process.env.REACT_APP_URL_HSEDESIGN_RU : process.env.REACT_APP_URL_DEZIIIGN;

  const privacyLink =
    i18n.language === 'ru' ? 'https://www.hse.ru/data_protection_regulation' : 'https://www.hse.ru/en/data_protection_regulation';

  const userShouldSignDocument = useMemo(() => (!isLPU && !!legalsList?.length && !!legalsList?.find((item: string) => item ===  DOCUMENT_ID)), [legalsList])

  const handleAcceptLegalsClick = () => {
    if (profile && profile?.accountId) {
      urlApi()?.acceptUserSign(profile.accountId, DOCUMENT_ID)
      .then((r) => {
        if (r.status === 200) {
          setTimeout(() => {
            setLegalsList(legalsList?.filter((i) => i !== DOCUMENT_ID))
          }, 1500)
        }
      })
      .catch((err) => console.error(err))
      .finally(() => {
        setTimeout(() => {
          setLegalsList(legalsList?.filter((i) => i !== DOCUMENT_ID))
        }, 1500)
      })
    }
  }

  useEffect(() => {
    if (profile && profile?.accountId) {
      urlApi()?.checkUserSign(profile.accountId).then((r: any) => setLegalsList(r))
    }
  }, [profile]);

  if (!userShouldSignDocument) {
    return null;
  }

  return (
    <>
    {userShouldSignDocument && (
      <LegalsWarningWrapper>
        <FlexBox style={{ padding: isMobile ? '15px 10px' : '0 0 0 0'}} align={'center'} alignMobile={'center'} direction='row' directionMobile='column' wrap={'nowrap'} width={'calc(80%)'} widthMobile={'calc(100%)'}>
          <LegalsText>
            {t('text.cookiesAgreement.part_1')}&nbsp;
          <a href={`${legalsLink}${LinkTo.legals}`} target={'_blank'}>{t('text.cookiesAgreement.part_2')}</a> {t('text.cookiesAgreement.part_3')} <a href={isHSEDesign || isAcademy ? privacyLink : `${legalsLink}${LinkTo.privacy}`}  target={'_blank'}>{t('text.cookiesAgreement.part_4')}</a> {t('text.cookiesAgreement.part_5')}
          </LegalsText>
          <LegalsApproveButton onClick={handleAcceptLegalsClick}>{t('text.cookiesAgree')}</LegalsApproveButton>
        </FlexBox>
      </LegalsWarningWrapper>
    )}
    </>
  )
}

export default LegalsWarning;
